import type React from 'react'
import type { Dispatch, SetStateAction } from 'react'

import { Modal } from 'components'

import * as S from './styles'

interface ModalOrderOverviewProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
  onReturn?: () => void
  children?: React.ReactNode
}

const ModalOrderOverview: React.FC<ModalOrderOverviewProps> = ({
  open,
  setOpen,
  onConfirm,
  onReturn = () => setOpen(false),
  children,
}) => {
  return (
    <Modal
      buttonAction={onConfirm}
      buttonText="Gerenciamento"
      closeAction={onReturn}
      modalWidth={456}
      open={open}
      returnAction={onReturn}
      returnIcon={''}
      returnText="Criar novo pedido"
      setOpen={setOpen}
      showClose={false}
      showReturn
      titleSize={22}
    >
      {children}
      <S.ObservationText>
        As OVs geradas serão <b>enviadas automaticamente ao SAP.</b> Materiais em aberto ou em
        análise <b>não possuem garantia de disponibilidade.</b>
      </S.ObservationText>
    </Modal>
  )
}

export default ModalOrderOverview
